<template>
	<div class="ZZRY">
		<div class="content ry">
			<div class="content_2 c3 lh7">
				<div class="f30">资质荣誉</div>
				<div class="f20 mb45">HONOR OF QUALIFICATION</div>
				<el-row :gutter="30">
					<template v-for="(item, i) in ZZRY">
						<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
							<transition name="el-fade-in-linear">
								<div v-show="show" style="transition: all 1s;-webkit-transition: all 1s;">
									<div class="ry_item tran3">
										<div class="img">
											<el-image v-if="!$store.state.mobile" style="width: 100%; height: auto" :src="item.src"
												:preview-src-list="srcList" />
											<img v-else :src="item.src" class="w100" @click="look(item.src)" />
										</div>
										<div class="tz f16 ls2 mt10">{{item.title}}</div>
									</div>
								</div>
							</transition>
						</el-col>
					</template>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				srcList: [],
				ZZRY: [
					{
						title: '国家级高新技术企业',
						src: require('@/assets/ZZRY_3.jpg')
					},
					{
						title: '4A级物流企业',
						src: require('@/assets/ZZRY_1.jpg')
					},
					{
						title: '吉林省科技小巨人企业',
						src: require('@/assets/ZZRY_2.jpg')
					},
					{
						title: '智慧物流专业委员会会员单位',
						src: require('@/assets/ZZRY_4.jpg')
					},
					{
						title: '专业委员会理事单位',
						src: require('@/assets/ZZRY_5.jpg')
					},
					{
						title: '长春市物流协会副会长单位',
						src: require('@/assets/ZZRY_6.jpg')
					},
					{
						title: '优秀非公企业党支部',
						src: require('@/assets/ZZRY_7.jpg')
					},
					{
						title: '中国仓储协会会员单位',
						src: require('@/assets/ZZRY_8.jpg')
					},
					{
						title: '3A级信用企业',
						src: require('@/assets/ZZRY_9.jpg')
					},
					{
						title: '环境管理体系认证证书',
						src: require('@/assets/ZZRY_10.jpg')
					},
					{
						title: '职业健康安全管理体系认证证书',
						src: require('@/assets/ZZRY_12.jpg')
					},
					{
						title: '质量管理体系认证证书',
						src: require('@/assets/ZZRY_13.jpg')
					},
					{
						title: '计算机软件著作权登记证书',
						src: require('@/assets/ZZRY_11.jpg')
					},
					{
						title: '发明专利证书',
						src: require('@/assets/ZZRY_14.jpg')
					},
					{
						title: '发明专利证书',
						src: require('@/assets/ZZRY_15.jpg')
					}
				]
			}
		},
		created() {
			this.ZZRY.forEach(x => this.srcList.push(x.src))
		},
		mounted() {
			this.$nextTick(() => {
				this.show = true
			})
		},
		methods: {
			look(url) {
				// console.log(url)
				window.open(url)
			}
		}
	}
</script>

<style lang="scss">
	.ZZRY {
		padding-bottom: 65px;
		@media screen and (max-width: 768px) {
			overflow: hidden;
		}
		.ry {
			padding-top: 65px;
			
			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}
				
				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}
				
				.f18 {
					font-size: 16px;
				}
				
				padding-left: 2vw;
				padding-right: 2vw;
				box-sizing: border-box;
				
			}

			.ry_item {
				margin-bottom: 30px;
				cursor: pointer;
				position: relative;
				padding: 20px;

				img {
					transition: all 0.3s;
				}

				&:hover {
					box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);
					-webkit-box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.12);
						
					@media screen and (max-width: 768px) {
						box-shadow: none!important;
					}
					// .img {
					// 	img {
					// 		transform: scale(1.12);
					// 	}
					// }
				}
			}
		}

		.el-image-viewer__canvas {
			transform: scale(2);
			-webkit-transform: scale(2);
		}

		.el-image {
			vertical-align: top;
		}
	}
</style>
